import { formatDate } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-notify-driver",
  templateUrl: "./admin-notify-driver.component.html",
  styleUrls: ["./admin-notify-driver.component.css"],
})
export class AdminNotifyDriverComponent implements OnInit {
  notifyform: FormGroup;
  workorderArray: any;
  token: any;
  vehicleArray: any;
  selectedWorkOrderQty: any;
  work_order_msg: any;
  dateFormat = "yyyy-MM-dd";
  language = "en";
  total_quantity: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  truckTypeNumber: any = -1;
  startPage: any = 1;
  page: any = -1;
  perPage: any = 100;
  loading: boolean = false;
  truckTypeList: any;
  workOrderQnty: any;
  work_order_qty: any;

  constructor(
    private formBuilder: FormBuilder,
    private matdialogref: MatDialogRef<AdminNotifyDriverComponent>,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.maxDate.setDate(this.maxDate.getDate() + 0);
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");

    this.notifyform = this.formBuilder.group({
      workorder_id: [""],
      price_per_ton: [""],
      work_order_date: [""],
      total_tons: [""],
      remaining_tons: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[1-9]\d*(\.\d+)?$/),
        ]),
      ],
      trip_booking_date: [""],
      truck_category: [""],
      trip_id: [""],
      work_order_quantity: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[1-9]\d*(\.\d+)?$/),
        ]),
      ],
      notification_radius: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[0-9]+$/),
        ]),
      ],
      price_ton: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[1-9]\d*(\.\d+)?$/),
        ]),
      ],
    });
    this.workOrder();
    this.GetTruckType(this.truckTypeNumber);
  }
  close() {
    this.matdialogref.close();
  }
  workOrder() {
    this.services.ListWorkOrder(this.token).subscribe(
      (response: any) => {
        this.vehicleArray = response.body.data;
        this.workorderArray = response.body;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public formatFormDate(date: Date) {
    return formatDate(date, this.dateFormat, this.language);
  }

  selectChangeHandler(item: any) {
    this.selectedWorkOrderQty = item;
    this.work_order_msg = item.workorder_id;
    let _id = this.notifyform.value.workorder_id;
    this.services
      .selectedWorkOrder(_id, this.token)
      .subscribe((response: any) => {
        this.notifyform.patchValue({
          price_per_ton: response.body.data.price_per_ton.toFixed(2),
          work_order_date: this.formatFormDate(response.body.data.createdAt),
        });
        this.total_quantity = response.body.data.remaining_tons.toFixed(3);
      });
    this.notifyform.get("remaining_tons")?.patchValue(item.remaining_tons);
    this.notifyform.get("total_tons")?.patchValue(item.total_tons);
  }

  public GetTruckType(type: any) {
    this.truckTypeNumber = type;
    this.services.GetTrucksTypeAll(this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckTypeList = response.body;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  remainingQnty(event: any) {
    this.workOrderQnty = event.target.value;
    this.work_order_qty =
      this.notifyform.value.remaining_tons - this.workOrderQnty;
    if (this.work_order_qty >= 0 || this.workOrderQnty == this.work_order_qty) {
      this.notifyform.patchValue({
        remaining_tons: this.work_order_qty,
      });
    } else {
      this.notifyform.patchValue({
        remaining_tons: this.notifyform.value.remaining_tons,
      });
      this.snackBar.open(
        "Work Order Quantity Should not Exceed With Remaining Quantity",
        "Fail",
        {
          duration: 5000,
        }
      );
    }
  }

  getTruckTypeId(truckCategory: string): string | null {
    const truckType = this.truckTypeList.find(
      (truck: any) => truck.category === truckCategory
    );
    return truckType ? truckType._id : null;
  }

  notify() {
    const truckCategory = this.notifyform.value.truck_category;
    const tripId = this.getTruckTypeId(truckCategory);
    let workDate = this.notifyform.value.work_order_date;
    if (!workDate) {
      this.snackBar.open("Please select WO", "Fail", {
        duration: 5000,
      });
      return;
    }
    let tripBooking = this.notifyform.value.trip_booking_date;
    if (!tripBooking) {
      this.snackBar.open("Please select trip booking date", "Fail", {
        duration: 5000,
      });
      return;
    }
    let truckCateg = this.notifyform.value.truck_category;
    if (!truckCateg) {
      this.snackBar.open("Please select truck type", "Fail", {
        duration: 5000,
      });
      return;
    }
    let price = this.notifyform.value.price_ton;
    if (!price) {
      this.snackBar.open("Please enter price per ton", "Fail", {
        duration: 5000,
      });
      return;
    }
    let workQty = this.notifyform.value.work_order_quantity;
    if (!workQty) {
      this.snackBar.open("Please enter work order quantity", "Fail", {
        duration: 5000,
      });
      return;
    }
    let notification = this.notifyform.value.notification_radius;
    if (!notification) {
      this.snackBar.open("Please enter notification radius", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.work_order_qty >= 0 || this.workOrderQnty == this.work_order_qty) {
      this.notifyform.patchValue({
        remaining_tons: this.work_order_qty,
      });
    } else {
      this.notifyform.patchValue({
        remaining_tons: this.notifyform.value.remaining_tons,
      });
      this.snackBar.open(
        "Work Order Quantity Should not Exceed With Remaining Quantity",
        "Fail",
        {
          duration: 5000,
        }
      );
    }
    const notifyObj = {
      workorder_id: this.notifyform.value.workorder_id,
      work_order_quantity: Number(this.notifyform.value.work_order_quantity),
      trip_booking_date: this.notifyform.value.trip_booking_date,
      truck_category: this.notifyform.value.truck_category,
      trip_id: tripId,
      price_per_ton: Number(this.notifyform.value.price_ton),
      notification_radius: Number(this.notifyform.value.notification_radius),
      remaining_tons: Number(this.notifyform.value.remaining_tons),
    };

    this.services.notifPushDriver(notifyObj, this.token).subscribe(
      (response: any) => {
        this.loading = true;
        if (response.status == 200) {
          this.matdialogref.close();
          this.snackBar.open(
            "Push notification has been informed to near by drivers",
            "Success",
            {
              duration: 5000,
            }
          );
          this.workOrder();
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
    this.loading = false;
  }
}
